<bulb-menubar
  *ngIf="hasCoverImage"
  [menuItems]="editControls"
  [formControl]="formControl"
></bulb-menubar>
<bulb-menubar
  *ngIf="!hasCoverImage"
  [menuItems]="noImageControls"
></bulb-menubar>
